import { a as c } from "./isArray-0d9c7aaa.mjs";
import { i as f, t as p } from "./toString-3b91b335.mjs";
import { M as u } from "./_getTag-4e44633b.mjs";
var h = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, m = /^\w*$/;
function y(r, t) {
  if (c(r))
    return !1;
  var n = typeof r;
  return n == "number" || n == "symbol" || n == "boolean" || r == null || f(r) ? !0 : m.test(r) || !h.test(r) || t != null && r in Object(t);
}
var d = "Expected a function";
function o(r, t) {
  if (typeof r != "function" || t != null && typeof t != "function")
    throw new TypeError(d);
  var n = function() {
    var e = arguments, a = t ? t.apply(this, e) : e[0], i = n.cache;
    if (i.has(a))
      return i.get(a);
    var s = r.apply(this, e);
    return n.cache = i.set(a, s) || i, s;
  };
  return n.cache = new (o.Cache || u)(), n;
}
o.Cache = u;
var g = 500;
function l(r) {
  var t = o(r, function(e) {
    return n.size === g && n.clear(), e;
  }), n = t.cache;
  return t;
}
var E = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, C = /\\(\\)?/g, I = l(function(r) {
  var t = [];
  return r.charCodeAt(0) === 46 && t.push(""), r.replace(E, function(n, e, a, i) {
    t.push(a ? i.replace(C, "$1") : e || n);
  }), t;
});
const P = I;
function T(r, t) {
  return c(r) ? r : y(r, t) ? [r] : P(p(r));
}
var w = 1 / 0;
function M(r) {
  if (typeof r == "string" || f(r))
    return r;
  var t = r + "";
  return t == "0" && 1 / r == -w ? "-0" : t;
}
function $(r, t) {
  t = T(t, r);
  for (var n = 0, e = t.length; r != null && n < e; )
    r = r[M(t[n++])];
  return n && n == e ? r : void 0;
}
function x(r) {
  return r;
}
export {
  y as a,
  $ as b,
  T as c,
  x as i,
  M as t
};
